import { Button, Grid } from "@mui/material";
import React from "react";
import { Edit as EditIcon } from "@mui/icons-material";

import useLeadInformation from "components/pages/transmissions/modal/patient/tabs/deviceInformation/leadInformation/useLeadInformation";

import LeadInformationForm from "components/pages/transmissions/modal/patient/tabs/deviceInformation/leadInformation/form/LeadInformationForm";
import LeadInformationPreview from "components/pages/transmissions/modal/patient/tabs/deviceInformation/leadInformation/preview/LeadInformationPreview";

const LeadInformation = () => {
  const {
    isLoading,
    isFetching,
    isLeadInformationLoading,

    isEditMode,
    handleEdit,

    leadFormData,
    setLeadFormData,

    handleCancel,
    handleSubmit,

    leads,
    setInitialLeads,
  } = useLeadInformation();

  return (
    <div className="patient-modal__section">
      <div className="patient-form__row patient-form__info">
        <div className="mb-3">
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <div className="patient-form__info--header">Lead Information</div>
            </Grid>
            {!isEditMode && (
              <Grid item>
                <Button
                  variant="text"
                  color="secondary"
                  onClick={handleEdit}
                  style={{ cursor: "pointer" }}
                  className="device-edit-button"
                >
                  <EditIcon
                    className="patient-edit-icon billing-cycle-edit-icon"
                    data-action="edit-lead-information-icon"
                  />
                  Edit
                </Button>
              </Grid>
            )}
          </Grid>

          {isEditMode ? (
            <LeadInformationForm
              leadFormData={leadFormData}
              setLeadFormData={setLeadFormData}
              setInitialLeads={setInitialLeads}
              handleSubmit={handleSubmit}
              handleCancel={handleCancel}
              isLoading={isLoading}
            />
          ) : (
            <LeadInformationPreview
              leads={leads}
              isLoading={isLeadInformationLoading || isFetching}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadInformation;
